<script>
import ApiClient from '../utils/ApiClient'

export default {
  data () {
    return {
      users: []
    }
  },
  /**
   * お気に入り楽曲を取得する
   * @param transactionId token
   **/
  findAllFavoriteTune: function (transactionId, callback, errorHandler) {
    var targetPath = 'ajax/favorite.php' + '?transactionid=' + transactionId
    ApiClient.search(targetPath, (response) => {
      callback(response.data)
    }, (error) => {
      console.log('getArtistList failed')
      console.log(error)
      errorHandler(error)
    })
  },
  /**
   * お気に入りリストに楽曲を追加する
   **/
  addFavoriteTune: function (params, callback, errorHandler) {
    var targetPath = 'ajax/favorite_add.php'
    ApiClient.create(targetPath, params, {}, (response) => {
      callback(response.data)
    }, (error) => {
      console.log('addFavoriteTune failed')
      console.log(error)
      errorHandler(error)
    })
  },
  /**
   * お気に入りリストから指定の楽曲を削除する
   **/
  removeFavoriteTune: function (params, callback, errorHandler) {
    var targetPath = 'ajax/favorite_delete.php'
    ApiClient.create(targetPath, params, {}, (response) => {
      callback(response.data)
    }, (error) => {
      console.log('addFavoriteTune failed')
      console.log(error)
      errorHandler(error)
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/services/FavoriteService.vue